// src/rtkQuery/features/hooks/usePatientInformationService.ts

import {
    usePostPatientInformationMutation,
    useGetPatientInformationQuery,
    useGetPatientEntitlementsQuery,
} from '@/rtkQuery/features/services/patientInformation/patientApi.slice';

export const usePatientInformationService = () => {
    const [
        triggerSubmit,
        {
            data: postData,
            error: postError,
            isLoading: postLoading,
            isSuccess: postSuccess,
            isError: postIsError,
            status: postStatus,
        },
    ] = usePostPatientInformationMutation();

    const postErrorMessage =
        (postError as any)?.message ||
        (postError as any)?.meta?.error ||
        (postError as any)?.data?.message ||
        'Something went wrong while submitting patient information';

    const {
        data: getData,
        error: getError,
        isLoading: getLoading,
        isSuccess: getSuccess,
        isError: getIsError,
        refetch: refetchPatientInfo,
        status: getStatus,
    } = useGetPatientInformationQuery();

    const getErrorMessage =
        (getError as any)?.meta?.error ||
        (getError as any)?.data?.message ||
        'Something went wrong while fetching patient information';

    const {
        data: entitlementsData,
        error: entitlementsError,
        isLoading: entitlementsLoading,
        isSuccess: entitlementsSuccess,
        isError: entitlementsIsError,
        status: entitlementsStatus,
        refetch: refetchEntitlements,
    } = useGetPatientEntitlementsQuery();

    const entitlementsErrorMessage =
        (entitlementsError as any)?.meta?.error ||
        (entitlementsError as any)?.data?.message ||
        'Something went wrong while fetching patient entitlements';



    return {
        submitPatientInformation: triggerSubmit,
        patientPostData: postData,
        patientPostError: postError,
        patientPostIsLoading: postLoading,
        patientPostIsSuccess: postSuccess,
        patientPostIsError: postIsError,
        patientPostStatus: postStatus,
        patientPostErrorMessage: postErrorMessage,

        getPatientInformation: getData,
        patientGetError: getError,
        patientGetIsLoading: getLoading,
        patientGetIsSuccess: getSuccess,
        patientGetIsError: getIsError,
        patientGetStatus: getStatus,
        patientGetErrorMessage: getErrorMessage,
        refetchPatientInformation: refetchPatientInfo,

        patientEntitlements: entitlementsData,
        patientEntitlementsError: entitlementsError,
        patientEntitlementsIsLoading: entitlementsLoading,
        patientEntitlementsIsSuccess: entitlementsSuccess,
        patientEntitlementsIsError: entitlementsIsError,
        patientEntitlementsStatus: entitlementsStatus,
        patientEntitlementsErrorMessage: entitlementsErrorMessage,
        refetchPatientEntitlements: refetchEntitlements,
    };
};
